<!-- 水电表 -->
<template>
  <el-dialog class="electric-water-meter-dialog"
             v-loading="loadData.loading"
             :title="`水电表-宿舍：${title.dormitoryName || null}第${title.floorNum || 0}层${title.roomName}【${title.dormitoryRoomType ? title.dormitoryRoomType.roomTypeName : '暂无房间'}】`"
             :visible.sync="show" :close-on-click-modal="false" width="820px" @close="close">
    <el-tabs v-model="actTab" type="card" v-if="visibleTabs">
      <!-- 不存在 title.electricDeviceId和title.regionId 时 隐藏除了 水电表设备码 模块以外的所有模块-->
      <template v-if="title.electricType!==2">
        <el-tab-pane label="电费充值记录" name="rechargeRecord" v-if="visibleMore">
          <charging-fee-record ref="rechargeRecordRef" :region-id="title.regionId" :id="id" />
        </el-tab-pane>
        <el-tab-pane label="电费赠送记录" name="freeRechargeRecord" v-if="visibleMore">
          <free-electricity-recharge-view :room-id="id" />
        </el-tab-pane>
      </template>
      <!--    显示本模块的判断：
              1.非院系专属宿舍
              2.非院系管理员
              3.该宿舍属于本院系分配的宿舍 -->
      <el-tab-pane label="水电表设备码" name="form"
                   v-if="!title.collegeId || !$store.state.login.userInfo.collegeId || $store.state.login.userInfo.collegeId === title.collegeId">
        <SetDormDeviceIdForm ref="setDormDeviceFormRef" v-if="title" :parent-data="title" @on-close="closed" />
      </el-tab-pane>
      <!--  title.electricDeviceId=存在电表    -->
      <el-tab-pane :label="title.electricType===1?'设置电表度数':'电费调度'" name="setElectricMeter"
                   v-permission="['electricMeter:batch:clear']"
                   v-if="!!((title.regionId && title.electricDeviceId) || title.meterNumber )">
        <!--     旧电表设置度数   -->
        <el-form v-if="title.electricType===1" ref="form" :model="formData" :rules="rules" label-width="240px">
          <el-form-item label="" label-width="0">
            <div class="tip">
              <p>用于电费调度或单独设置电表清零，支持精确到小数点后两位的度数调整。</p>
              <p>示例：</p>
              A电表设置为47.25度（原值77.25度，扣减30度），B电表设置为80度（原值50度，增加30度)。
            </div>
          </el-form-item>
          <el-form-item label="房间号(厂家标识)" prop="regionId">
            <div class="form-item-read">{{ title.regionId }}</div>
          </el-form-item>
          <!--    掌控电表-flowBalance    新电表-rechargeNumber    -->
          <el-form-item :label="`设置电表度数(原度数：${title.flowBalance})`" prop="value">
            <tool-tips-group is-flex
                             tips-content="请注意：<br/>在电表设置到执行之间有一个<b style='color:var(--color-danger);'>6分钟</b>的等待期。<br/>在这段时间内，如果宿舍继续用电，将会产生一定的误差。">
              <el-input v-model.trim="formData.value" />
            </tool-tips-group>
          </el-form-item>
        </el-form>
        <!--     新电表 设置电表度数   -->
        <el-form v-else-if="title.electricType===2" ref="form" :model="formData" :rules="rules" label-width="240px">
          <el-form-item label="" label-width="0">
            <div class="tip">
              <p>实现电表电费调度功能，用于修正电表充错电费的情况。支持设置正负数值。</p>
              <p>示例：</p>
              A电表设置为-30（扣减30度），B电表设置为+30（增加30度），系统将自动调整并计算最终结果。
            </div>
          </el-form-item>
          <el-form-item :label="`设置电表度数(原度数：${title.flowBalance})`" prop="rechargeNumber">
            <tool-tips-group
              tips-content="请注意：<br/>在电表设置到执行之间有一个<b style='color:var(--color-danger);'>6分钟</b>的等待期。<br/>在这段时间内，如果宿舍继续用电，将会产生一定的误差。">
              <el-input-number :min="-10000" :max="10000" :precision="2" :step="1"
                               size="small"
                               controls-position="right"
                               v-model="formData.rechargeNumber" @change="handleTotal" />
            </tool-tips-group>
          </el-form-item>
          <el-form-item :label="`价值金额(${electricityRate}元/度)`" prop="rechargeAmount">
            <el-input-number :min="0" :max="10000" :precision="2"
                             size="small"
                             :step="1"
                             controls-position="right"
                             v-model="formData.rechargeAmount" />
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input v-model="formData.remarks" />
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="title.electricType===2?'充值/赠送/清零记录':'电表设置记录'" name="electricMeterSetRecord"
                   v-permission="['electricMeter:batch:clear']"
                   v-if="visibleMore">
        <!--    新电表 充值记录、赠送记录、设置记录都合在同一个模块，通过条件筛选展示    -->
        <NewElectricMeterSetRecordView v-if="title.electricType===2" :parent-data="title" />
        <ElectricMeterSetRecordView v-else :parent-data="title" />
      </el-tab-pane>
      <el-tab-pane label="电量记录" v-if="visibleMore" name="electricityBillRecords">
        <NewElectricityBillRecords v-if="title.electricType===2" name="NewElectricMeterSetRecordView"
                                   :parent-data="title" />
        <electricity-bill-records v-else-if="title.electricType===1" :parent-data="title" :region-id="title.regionId" />
      </el-tab-pane>
      <el-tab-pane v-if="title.electricType===2||title.waterType===2" label="开关电表" name="toggleElectricMeter"
                   class="mt-1 font-center">
        <el-divider>当前电表状态：{{ title.meterSwitch === 'ON' ? '打开' : '关闭' }}</el-divider>
        <el-button type="primary" @click="toggleElectricMeter">{{ title.meterSwitch === 'ON' ? '关闭' : '打开' }}电表
        </el-button>
        <template v-if="title.waterType===2">
          <el-divider>水表控制</el-divider>
          <div class="flex" style="justify-content: center;align-items: center">
            <el-switch
              v-role="['开发人员']"
              size="large"
              v-model="waterFlag"
              active-color="var(--color-success)"
              inactive-color="#d0d6e8"
              :active-value="1"
              active-text="开启"
              :inactive-value="0"
              inactive-text="关闭"
              @change="handleWaterFlag" />
            <el-button type="primary" size="small" plain icon="el-icon-refresh" class="ml-1" @click="resetWaterMeter">
              水表占用重置
            </el-button>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <div v-if="actTab!=='form'||(title.waterType===1&&title.electricType===1&&actTab==='form')" class="font-center">
        <el-button @click="close">关 闭</el-button>
        <!-- 设置电表度数  -->
        <template v-if="actTab === 'setElectricMeter'">
          <!--    新电表=2，旧电表=1      -->
          <el-button v-if="title.electricType===1" type="success"
                     @click="save('手动设置电表度数（请注意：设置后到执行需要6分钟的处理时间。期间内，如果宿舍继续用电，将产生一定的误差！）', setSingleElectricMeterApi, '电表度数设置成功，将在15分钟内生效！')">
            更新电表
          </el-button>
          <el-button v-else-if="title.electricType===2" type="success"
                     @click="save('手动设置电表度数（请注意：如果设置期间宿舍继续用电，将产生一定的误差！）', setSingleNewElectricMeterApi, '电表度数设置成功！')">
            更新电表
          </el-button>
        </template>
        <!--  水电表设备码修改后在此保存  -->
        <el-button v-else-if="!!$refs.setDormDeviceFormRef&&(title.electricType!==2)" type="primary"
                   @click="$refs.setDormDeviceFormRef.save('水电表信息', addDormRoom, '水电表信息更新成功！')">保 存
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import { addDormRoom } from '@/api/dorm'
import FreeElectricityRechargeView from '@/views/pages/dormManage/dialog/freeElectricityRechargeView.vue'
import electricityBillRecords from '@/views/pages/dormManage/dialog/electricityBillRecords.vue'
import SetDormDeviceIdForm from '@/views/pages/dormManage/dialog/setDormDeviceIdForm.vue'
import {
  getNewElectricMeterInfoByRoomIdApi,
  setSingleElectricMeterApi,
  setSingleNewElectricMeterApi
} from '@/api/dorm/set-electric-meter-api'
import ElectricMeterSetRecordView from '@/views/pages/dormManage/dialog/ElectricMeterSetRecordView.vue'
import NewElectricMeterSetRecordView from '@/views/pages/dormManage/dialog/NewElectricMeterSetRecordView.vue'
import ChargingFeeRecord from '@/views/pages/financeManage/chargingFeeRecord/chargingFeeRecord.vue'
import NewElectricityBillRecords from '@/views/pages/dormManage/dialog/NewElectricityBillRecords.vue'
import { getSysParamsByKey } from '@/api/sysParams'
import { Decimal } from 'decimal.js'
import { turnOffNewElectricityMeterApi, turnOnNewElectricityMeterApi } from '@/api/dorm/free-electric-api'
import { turnOnNewWaterMeterApi, turnOffNewWaterMeterApi, resetNewWaterMeterApi } from '@/api/logistics/water-meter-api'

export default {
  name: 'electricWaterMeterDialog',
  components: {
    NewElectricityBillRecords,
    ChargingFeeRecord,
    ElectricMeterSetRecordView,
    NewElectricMeterSetRecordView,
    SetDormDeviceIdForm,
    FreeElectricityRechargeView,
    electricityBillRecords
  },
  mixins: [dialog],
  props: {
    userTypeList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      electricityRate: 10, // 电价
      actTab: 'rechargeRecord',
      waterFlag: 0, // 水表开关
      visibleTabs: true,
      formData: {
        roomIds: [''],
        value: undefined
      },
      rules: {
        rechargeNumber: [{
          required: true,
          message: '请输入要设置的电表度数',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (value) {
              if (+value < 0 && Math.abs(value) > Math.abs(this.title.flowBalance)) {
                return callback(new Error('减去度数不能超出电表原度数!'))
              } else {
                return callback()
              }
            } else {
              return callback(new Error('请输入电表度数'))
            }
          },
          trigger: 'blur'
        }],
        value: [
          {
            required: true,
            message: '请输入要设置的电表度数',
            trigger: 'blur'
          },
          this.$store.state.commonValidate.validatorTwoDecimalPlacesObj,
          {
            validator: (rule, value, callback) => {
              if (value && (Number(value) < 0 || Number(value) > 650)) {
                return callback(new Error('仅支持0~650以内的数值!'))
              } else {
                return callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    'title.electricType': function(val) {
      switch (+val) {
        case 1:
          this.formData = {
            roomIds: [this.id],
            value: undefined
          }
          break
        case 2:
          this.formData = {
            dormitoryRoomId: this.title.id,
            rechargeAmount: 0,
            rechargeNumber: 0,
            remarks: '',
            userId: null
          }
          break
        default:
          this.formData = {}
          break
      }
    }
  },
  computed: {
    visibleMore() {
      // 用于判断电表是否已设置电表码；
      // 1。新电表需要 electricType=1 && 存在meterNumber
      let result = false
      if (this.title?.electricType === 2) {
        result = !!this.title.meterNumber
      } else {
        // 2.掌控电表需要确认 this.title.regionId && this.title.electricDeviceId
        result = !!(this.title.regionId && this.title.electricDeviceId)
      }
      return result
    }
  },
  async mounted() {
    this.getElectricityRate()
    await this.$nextTick()
    if (!this.id) {
      this.$message.error('请求失败，请重试！')
    }
    this.preTitle = '更新'
    if (this.title.electricType === 2 && (this.title.electricDeviceId || this.title.regionId || this.title.meterNumber)) {
      await this.getElectricMeterInfoByRoomId(this.id)
      this.actTab = 'electricMeterSetRecord'
    }
    // 安装了电表（存在regionId和 electricDeviceId）时，获取电表信息
    if (!this.visibleMore) {
      this.actTab = 'form'
    }
  },
  methods: {
    addDormRoom, // 保存api
    setSingleElectricMeterApi, // 设置单个 掌控电表 度数
    setSingleNewElectricMeterApi, // 设置单个 新电表 度数
    // 根据房间id获取新电表信息
    async getElectricMeterInfoByRoomId(roomId) {
      try {
        this.loadData.loading = true
        // this.visibleTabs = false
        const { data } = await getNewElectricMeterInfoByRoomIdApi(roomId)
        // this.title.dormitoryRoomId = this.id
        // this.title.meterNumber = ''
        // this.title.meterNumber = data.meterNumber || ''
        if (data.meterSwitch) {
          this.title.meterSwitch = data.meterSwitch
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loadData.loading = false
        // this.visibleTabs = true
      }
    },
    // 获取系统设置电价，用于估算电费价值
    getElectricityRate() {
      getSysParamsByKey('oneDegreeHowMoney').then(res => {
        if (res.data) {
          this.electricityRate = +res.data.paramValue
        }
      })
    },
    // 开启关闭 水电表
    toggleElectricMeter() {
      this.$confirm(`是否确定${this.title.meterSwitch === 'on' ? '关闭' : '开启'}水表?`).then(async () => {
        try {
          const api = this.title.meterSwitch === 'ON' ? turnOffNewElectricityMeterApi : turnOnNewElectricityMeterApi
          await api(this.title.id)
          this.$message.success('操作成功')
          await this.getElectricMeterInfoByRoomId(this.title.id)
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {
      })
    },
    // 开关水表
    handleWaterFlag() {
      const api = this.waterFlag === 1 ? turnOnNewWaterMeterApi : turnOffNewWaterMeterApi
      const msg = this.waterFlag === 1 ? '开启' : '关闭'
      try {
        api({ dormitoryRoomId: this.title.id }).then(() => {
          this.$message.success(`${msg}成功`)
        })
      } catch (e) {
        this.waterFlag = this.waterFlag ? 0 : 1
        console.error(e)
      }
    },
    // 开关水表
    resetWaterMeter() {
      console.log(this.title)
      this.$confirm(`此操作会重置${this.title.roomName}的水表占用状态，是否继续？?`, '重置水表').then(() => {
        try {
          resetNewWaterMeterApi(this.title.id).then(() => {
            this.$message.success('水表重置成功，可重新开启。')
          })
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {
      })
    },
    handleTotal(val) {
      this.formData.rechargeAmount = new Decimal(this.electricityRate).mul(val).toNumber()
    }
  }
}
</script>
<style lang="scss">
.electric-water-meter-dialog {
  .el-dialog {
    margin: 10px auto 20px !important;

    .el-dialog__body {
      min-height: 687px;

      .charging-fee-record {
        padding-top: 0;
      }
    }
  }
}
</style>
